import { cn } from "@/lib/utils";
import { Icon, type IconName } from "./icon";

// Document-readiness chip, ported from the prototype's styles.css `.doc-chip*`
// (roster passport/DNI status). Per docs/design-system.md §4: ok = success,
// warn (expiring) = warning, expired = danger, missing = faint.
export type DocStatus = "ok" | "warn" | "expired" | "missing";

const DOC_CLASS: Record<DocStatus, string> = {
  ok: "doc-ok",
  warn: "doc-warn",
  expired: "doc-expired",
  missing: "doc-missing",
};

export interface DocChipProps {
  status: DocStatus;
  label: string;
  icon?: IconName;
  /** Leading-icon size in px (defaults to 13). */
  iconSize?: number;
}

export function DocChip({ status, label, icon, iconSize = 13 }: DocChipProps) {
  return (
    <span className={cn("doc-chip", DOC_CLASS[status])}>
      {icon && <Icon name={icon} size={iconSize} />}
      {label}
    </span>
  );
}
